let vmSearchPage = null;

if (document.getElementById("searchPage")) {   
    vmSearchPage = new Vue({
        el: '#searchPage',
        data: () => ({
            windowWidth: window.innerWidth,
            showFilter: false,
            pagination: {
                currentPage: 1,
                numPages: 1,
            },
            error: "",
            total: 0,
            maxSize: 10,
            searchData: [],
            filter: [],
            contentFilter: [
                "Articles",
                "Events",
                "News",
                "Resources",
                "Updates",
                "Changes",
                "Change Pack"
            ],
            typeFilter: [
                "Article",
                "Document",
                "External Link"
            ],
            selectedType: [],
            selectedContent: [],
            showResultInfo: false
        }),
        methods: {
            getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for(var i = 0; i<vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) { return pair[1]; }
                }
                return "";
            },
            getData(paginationPosition) {
                if (paginationPosition) {
                    paginationPosition = 1;
                } else {
                    paginationPosition = this.pagination.currentPage
                }
                const self = this;
                document.querySelector('html').classList.add("loading");
                self.error = "";
                self.showResultInfo = false;
                axios.post("/umbraco/api/xoserveapi/SearchTool", {
                    "Customer": "",
                    "Category": "",
                    "ResourceType": self.selectedType.join(';').replace(/ /g, ""),
                    "OrderBy":  "",
                    "SearchTerm": self.term,
                    "PageNumber": paginationPosition,
                    "Phase": "",
                    "Status": "",
                    "Topic": "",
                    "Release": "",
                    "ContentType": self.selectedContent.join(';').replace(/ /g, ""),
                    "NodeId":""
                })
                    .then(function (response) {
                        self.searchData = response.data.Results;  
                        self.total = response.data.TotalNumberOfRecords;
                        self.maxSize = response.data.PageSize;
                        self.pagination.currentPage = response.data.PageNumber; 
                        self.showResultInfo = true;
                    })
                    .then(function () {                        
                        $('html, body').animate({
                            scrollTop: $('.main').offset().top
                        }, 300, function () {
                             document.querySelector('html').classList.remove("loading");
                         })
                    })                    
                    .catch(function (error) {
                        self.error = error;
                    });
            },
            onResize() {
                this.windowWidth = window.innerWidth
            }
        },
        mounted() {   
            this.getData();
            const self = this;
            window.addEventListener('resize', function () {
                self.windowWidth = window.innerWidth
            })
        },
        computed: {    
            term() {
                return decodeURI(this.getQueryVariable("term")); //.replace(/%20/g, " ");
            }, 
            showToggle() {
                if (this.windowWidth > 768) {
                    this.showFilter = false;
                    return true
                } else  {
                    return this.showFilter
                }
            },
            resultsText() {
                let text = this.total + " results";
                if (this.showResultInfo) {
                    if (this.term.length > 0) {
                        text += " for <span class='text-bolder'>'" + this.term + "'</span>"
                    }
                    if (this.selectedContent.length > 0 || this.selectedType.length > 0) {
                        text += " in"
                        if (this.selectedContent.length > 0) {
                            text += " By Content: " + this.selectedContent
                        }
                        if (this.selectedType.length > 0) {
                            if (this.selectedContent.length > 0) {
                                text += " and By Content Type: " + this.selectedType
                            } else {
                                text += " By Content Type: " + this.selectedType
                            }
                        }
                    }
                    return text;
                } else {
                    return "Loading..."
                }
            }
        },       
    })
}